angular.module('app').factory('configsService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer)
        {
            Configurer.setBaseUrl(settings.apiURL);
        });

        var configs = restAngular.all("/config/");

        return {
            getConfigsMenu: function () {
                return configs.
                    one("get").
                    get();
            },
            getConfigByConfigSkinId: function (configId) {
                return configs.
                    one("get").
                    get({config_id: configId})
            },
            updateConfigByConfigSkinId: function (configData) {
                return configs.
                    one("change").
                    post("", {config: configData})
            },
            generateJs: function () {
                return configs.
                    one("generateJS").
                    get()
            },
            createConfig: function (configData) {
                return configs.
                    one("create").
                    post("", {config: configData})
            },
            editConfig: function (configData) {
                return configs.
                    one("changeTree").
                    post("", {config: configData})
            },
            getConfigTypes: function () {
                return configs.
                    one("getTypes").
                    get()
            },
            applyConfigs: function () {
                return configs.
                    one("apply").
                    get()
            }
        }
    }
]);